import React from 'react';

const PhoneInputWidget = ({ countryCode, phoneNumber, onChange, nameCode, namePhone }) => {
  // Lista de países común (puedes ampliarla)
  const countries = [
    { code: '57', flag: '🇨🇴', name: 'Colombia' },
    { code: '52', flag: '🇲🇽', name: 'México' },
    { code: '34', flag: '🇪🇸', name: 'España' },
    { code: '51', flag: '🇵🇪', name: 'Perú' },
    { code: '54', flag: '🇦🇷', name: 'Argentina' },
    { code: '56', flag: '🇨🇱', name: 'Chile' },
    { code: '1', flag: '🇺🇸', name: 'USA/Canadá' },
  ];

  return (
    <div className="flex flex-col">
      <label className="mb-1 flex items-center font-medium text-gray-700">
        Número de Celular:
        <span className="text-red-500 ml-1">*</span>
      </label>
      
      <div className="flex gap-2">
        {/* Selector de País */}
        <div className="relative w-32">
          <select
            name={nameCode}
            value={countryCode}
            onChange={onChange}
            className="p-2 border border-gray-300 rounded w-full bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none cursor-pointer"
          >
            {countries.map((country) => (
              <option key={country.code} value={country.code}>
                {country.flag} +{country.code}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg className="fill-current h-4 w-4" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>

        {/* Input de Número */}
        <input
          type="tel"
          name={namePhone}
          value={phoneNumber}
          onChange={onChange}
          placeholder="316 123 4567"
          className="flex-1 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
          required
          maxLength={10}
        />
      </div>
      <p className="text-xs text-gray-400 mt-1">Selecciona tu país e ingresa los 10 dígitos de tu celular.</p>
    </div>
  );
};

export default PhoneInputWidget;